import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { ToastProvider } from '@/components/feature/ToastProvider';
import Hero from '@/pages/home/components/Hero';
import TodayMelons from '@/pages/home/components/TodayMelons';
import TimelineSection from '@/pages/home/components/TimelineSection';
import RollingFeed from '@/pages/home/components/RollingFeed';
import CommunityTalk from '@/pages/home/components/CommunityTalk';
import FaqTrust from '@/pages/home/components/FaqTrust';

export default function Home() {
  return (
    <ToastProvider>
      <div className="min-h-screen w-full bg-background-50">
        <SiteHeader />
        <main>
          <Hero />
          <TodayMelons />
          <TimelineSection />
          <RollingFeed />
          <CommunityTalk />
          <FaqTrust />
        </main>
        <SiteFooter />
      </div>
    </ToastProvider>
  );
}